export default __webpack_public_path__ + "static/media/calander.5752dfcd.png";